import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { ChangeUsernameSuccessComponent } from "./change-username-success.component";


class ChangeUsernameSuccessFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    changeUsernameSuccessComponentRef: ComponentRef<ChangeUsernameSuccessComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside change username success form constructor');
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('Change Username Form session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('Change Username Form session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('Change Username Success Form session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<ChangeUsernameSuccessComponent> = self.resolver.resolveComponentFactory(ChangeUsernameSuccessComponent);
        self.changeUsernameSuccessComponentRef = self.viewContainerRef.createComponent(factory);

        console.log('change usernameSuccessFormTs constructor payload:', this.payload);

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              console.log('change usernameSuccessFormTs createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('change usernameSuccessFormTs createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('change usernameSuccessFormTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('change usernameSuccessFormTs onError for ' + this.formId + ' payload:', payload);
      }

}

interface ActionsInPayload {
    [key: string]: any;
  }

export default ChangeUsernameSuccessFormSession;
